"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var KpiRecordConverter_1 = require("./KpiRecordConverter");

var KpiRecordConverterImpl_1 = require("./KpiRecordConverterImpl");
/**
 *
 * @author Stepan Mik
 */


var KpiAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(KpiAppModule, _AppModule_1$AppModul);

  function KpiAppModule() {
    var _this;

    _classCallCheck(this, KpiAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(KpiAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'kpiAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(KpiAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(KpiRecordConverter_1.KpiRecordConverter).to(KpiRecordConverterImpl_1.KpiRecordConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return KpiAppModule;
}(AppModule_1.AppModule);

exports.KpiAppModule = KpiAppModule;